import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./pressure.css";

import { Link } from "react-router-dom";
export default function MaritimeExpertiseView() {
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 700,
    pauseOnHover: false,
  };

  return (
    <>
      <Header />

      <main className="prs">
        {/* ===== HERO ===== */}
        <section className="prs-hero">
          <div className="prs-hero__text">
            <h1>Expertise Maritime & Portuaire</h1>
            <p>
              VERATRAC SAFETY propose des prestations complètes d’expertise
              maritime, de contrôle des équipements embarqués et de
              certification de conformité pour garantir la sécurité des
              navires, des installations portuaires et des équipages.
            </p>

            <div className="prs-hero__bullets">
              <span>⚓ Expertise technique & réglementaire</span>
              <span>🚢 Inspection navale & levage portuaire</span>
              <span>🧭 Certification et conformité internationale</span>
            </div>

            <a href="#contact" className="btn-primary">
              Demander une inspection
            </a>
          </div>

          <div className="prs-hero__slider">
            <Slider {...sliderSettings}>
              <div><img src="/images/maritime/1.jpg" alt="Inspection navale" /></div>
              <div><img src="/images/maritime/2.jpg" alt="Pont portuaire" /></div>
              <div><img src="/images/maritime/3.jpg" alt="Grue de quai" /></div>
              <div><img src="/images/maritime/4.jpg" alt="Appareillage marin" /></div>
              <div><img src="/images/maritime/5.jpg" alt="Équipements sous pression à bord" /></div>
            </Slider>
          </div>
        </section>

        {/* ===== SECTION EXPERTISE ===== */}
        <section className="prs-reglement prs-simple">
          <h2>Notre expertise maritime</h2>
          <p>
            Nous accompagnons les armateurs, chantiers navals, opérateurs
            portuaires et organismes de classification dans l’évaluation
            technique et réglementaire des équipements de bord et des
            infrastructures maritimes.  
            Nos missions couvrent aussi bien les navires de commerce que
            les unités offshore, bateaux de pêche ou embarcations de servitude.
          </p>

          <h3>Domaines d’intervention</h3>
          <ul>
            <li>Contrôle des appareils de levage embarqués (grues, treuils, portiques).</li>
            <li>Inspection des réservoirs, circuits hydrauliques et équipements sous pression.</li>
            <li>Contrôle des dispositifs de sécurité : pompes incendie, moyens de sauvetage, armoires CO₂.</li>
            <li>Vérification de conformité des installations électriques de bord.</li>
            <li>Suivi technique des opérations portuaires et levage sur quais.</li>
          </ul>

          <h3>Références normatives</h3>
          <p>
            Nos inspections sont réalisées conformément aux exigences du
            <strong> Code ISM (International Safety Management) </strong>,
            du <strong> Code ISPS </strong>, et des conventions
            <strong> SOLAS </strong> et <strong> MARPOL </strong>.
            Nous appliquons également les directives
            <strong> Bureau Veritas, DNV, Lloyd’s Register </strong> ou toute
            autre société de classification mandatée.
          </p>

          <h3>Types de prestations</h3>
          <ul>
            <li>Expertise avant achat, avarie ou sinistre maritime.</li>
            <li>Inspection de levage à bord (statique, dynamique et structurelle).</li>
            <li>Contrôle périodique des installations portuaires.</li>
            <li>Audit de conformité documentaire et traçabilité réglementaire.</li>
            <li>Assistance technique à la remise en service après travaux.</li>
          </ul>

          <h3>Nos atouts</h3>
          <ul>
            
            <li>Équipements portables d’inspection certifiés (ultrasons, manomètres, capteurs de charge).</li>
            <li>Intervention sur tout le littoral marocain et zones portuaires spécialisées (Tanger Med, Casablanca, Safi, Jorf Lasfar...).</li>
          </ul>

          <h3>Livrables</h3>
          <p>
            À l’issue de chaque mission, un <strong>rapport d’expertise maritime complet</strong> est délivré,
            comprenant :
          </p>
          <ul>
            <li>Les constats techniques et photographiques ;</li>
            <li>Les écarts ou non-conformités observées ;</li>
            <li>Les recommandations et plan d’action correctif ;</li>
            <li>Une attestation de conformité réglementaire.</li>
          </ul>

          <div className="prs-btns">
            <Link to="/#contact" className="btn-primary">faire une consultation</Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
